import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", once = true, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, desc, dark = false, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal><p className="eyebrow mb-5">{eyebrow}</p></Reveal>
    <Reveal delay={0.08}>
      <h2 className={`h-display text-3xl sm:text-4xl lg:text-5xl text-balance ${dark ? "text-linen" : "text-ink"}`}>{title}</h2>
    </Reveal>
    {desc && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? "text-linen/60" : "text-stone"}`}>{desc}</p>
      </Reveal>
    )}
  </div>
);
